import React, { useRef, useEffect, useState } from "react";
import styles from "./tooltip.module.scss";
import { KoText, KoTitle } from "packages/typography";
import KoProgressCircle from "packages/progressCircle";
import KoStaicMembers from "packages/staticMember";

export const Tooltip = ({
  task,
  rowHeight,
  rtl,
  svgContainerHeight,
  svgContainerWidth,
  scrollX,
  scrollY,
  arrowIndent,
  fontSize,
  fontFamily,
  headerHeight,
  taskListWidth,
  TooltipContent
}) => {
  const tooltipRef = useRef(null);
  const [relatedY, setRelatedY] = useState(0);
  const [relatedX, setRelatedX] = useState(0);

  useEffect(() => {
    if (tooltipRef.current) {
      const tooltipHeight = tooltipRef.current.offsetHeight * 1.1;
      const tooltipWidth = tooltipRef.current.offsetWidth * 1.1;

      let newRelatedY = task.index * rowHeight - scrollY + headerHeight;
      let newRelatedX;

      // RTL mode
      if (rtl) {
        newRelatedX = task.x1 - arrowIndent * 1.5 - tooltipWidth - scrollX;

        if (newRelatedX < 0) {
          newRelatedX = task.x2 + arrowIndent * 1.5 - scrollX;
        }

        const tooltipLeftmostPoint = tooltipWidth + newRelatedX;

        if (tooltipLeftmostPoint > svgContainerWidth) {
          newRelatedX = svgContainerWidth - tooltipWidth;
          newRelatedY += rowHeight;
        }
      }
      // LTR mode
      else {
        newRelatedX = task.x2 + arrowIndent * 1.5 + taskListWidth - scrollX;

        const tooltipLeftmostPoint = tooltipWidth + newRelatedX;
        const fullChartWidth = taskListWidth + svgContainerWidth;

        if (tooltipLeftmostPoint > fullChartWidth) {
          newRelatedX =
            task.x1 +
            taskListWidth -
            arrowIndent * 1.5 -
            scrollX -
            tooltipWidth;
        }

        if (newRelatedX < taskListWidth) {
          newRelatedX = svgContainerWidth + taskListWidth - tooltipWidth;
          newRelatedY += rowHeight;
        }
      }

      const tooltipLowerPoint = tooltipHeight + newRelatedY - scrollY;

      if (tooltipLowerPoint > svgContainerHeight - scrollY) {
        newRelatedY = svgContainerHeight - tooltipHeight;
      }

      setRelatedY(newRelatedY);
      setRelatedX(newRelatedX);
    }
  }, [
    tooltipRef,
    task,
    arrowIndent,
    scrollX,
    scrollY,
    headerHeight,
    taskListWidth,
    rowHeight,
    svgContainerHeight,
    svgContainerWidth,
    rtl
  ]);

  return (
    <div
      ref={tooltipRef}
      className={
        relatedX
          ? styles.tooltipDetailsContainer
          : styles.tooltipDetailsContainerHidden
      }
      style={{ left: relatedX, top: relatedY }}
    >
      <TooltipContent task={task} fontSize={fontSize} fontFamily={fontFamily} />
    </div>
  );
};

export const StandardTooltipContent = ({ task, fontSize, fontFamily }) => {
 
  console.log(task);
  return (
    <div className={styles.tooltipDefaultContainer} >
      <div className={styles.dates}>
        <KoText text= {`${task.start.getDate()}-${
          task.start.getMonth() + 1
        }-${task.start.getFullYear()} - ${task.end.getDate()}-${
          task.end.getMonth() + 1
        }-${task.end.getFullYear()}`} />
      </div>
      <KoTitle ellipsis={true} level={4} text={task.name} className={styles.title} />
      <KoText text={`Duration: ${~~(
        (task.end.getTime() - task.start.getTime()) /
            (1000 * 60 * 60 * 24)
      )} day(s)`} />
      <div className={styles.assignees}>
        <div className={styles.assignee}>
          <KoText className={styles.label} text={'Assignee'} />
          <KoStaicMembers data={task.assigneeProfile} />
        </div>
        <div className={styles.assignee}>
          <KoText className={styles.label} text={'Reporter'} />
          <KoStaicMembers data={task.reporterProfile} />
        </div>
      </div>
      <div className={styles.tooltipDefaultContainerParagraph}>
        {!!task.progress &&  <KoProgressCircle size={35} strokeColor={`var(--palette-success-main)`} type="circle" percent={task.progress} />}
      </div>
    </div>
  );
};
